import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";

export default function StandardsButton({ url, number }) {
  const navigate = useNavigate();

  if (url !== "prek") {
    return (
      <button
        type="button"
        className="button-flat-color round dimensional cyan auto standards"
        onClick={() => {
          const location = {
            pathname: routeCodes.STANDARDS,
            search: `?grade=${number}`,
          };
          navigate(location);
        }}
      >
        {getString("grades.standards", [url.toUpperCase()])}
      </button>
    );
  }
  return null;
}

StandardsButton.propTypes = {
  url: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
};
